var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollaboration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4669 14.0008C11.3741 14.0008 8.86694 11.4936 8.86694 8.40078C8.86694 5.30799 11.3741 2.80078 14.4669 2.80078C17.5597 2.80078 20.0669 5.30799 20.0669 8.40078C20.0669 11.4936 17.5597 14.0008 14.4669 14.0008Z",
    fill: "#FBA12B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.24146 21.4683C1.24146 22.3434 1.4865 23.1719 1.91824 23.872C2.72338 25.2256 4.2053 26.1357 5.90894 26.1357C7.61257 26.1357 9.09449 25.2256 9.89963 23.872C10.3314 23.1719 10.5764 22.3434 10.5764 21.4683C10.5764 18.8895 8.48772 16.8008 5.90894 16.8008C3.33015 16.8008 1.24146 18.8895 1.24146 21.4683Z",
    fill: "#FBA12B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1156 23.1611V19.7734M4.70312 23.1611V19.7734",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1318 25.2008C12.3365 25.2008 11.8333 24.2927 12.0797 23.5365C12.3022 22.8534 12.4225 22.124 12.4225 21.3666C12.4225 20.3447 12.2035 19.3739 11.8099 18.4986C11.5271 17.8697 11.8003 17.0762 12.4806 16.9633C13.1223 16.8567 13.7866 16.8008 14.4669 16.8008C19.8682 16.8008 24.2669 20.3288 24.2669 24.6758C24.2669 24.9698 24.0297 25.2008 23.7279 25.2008H13.1318Z",
    fill: "#FBA12B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaboration);
export default __webpack_public_path__ + "static/media/Collaboration.968601b01adbc90b6225b8c548a5f897.svg";
export { ForwardRef as ReactComponent };